/**
 * Универсальный слой совместимости Telegram <-> MAX WebApp.
 * Определяет платформу и предоставляет единый API.
 */

function detectPlatform() {
    if (window.Telegram && window.Telegram.WebApp) return 'telegram';
    if (window.WebApp && !window.Telegram) return 'max';
    // Fallback: проверяем URL
    if (window.location.search.includes('telegram_auth_token')) return 'telegram';
    return 'unknown';
}

const platform = detectPlatform();

function getWebApp() {
    if (platform === 'telegram') return window.Telegram.WebApp;
    if (platform === 'max') return window.WebApp;
    return null;
}

const webapp = getWebApp();

// --- Единый API ---

export function getPlatform() {
    return platform;
}

export function getAuthToken() {
    // Telegram: из URL ?telegram_auth_token=...
    const params = new URLSearchParams(window.location.search);
    const tgToken = params.get('telegram_auth_token');
    if (tgToken) return tgToken;

    // MAX: из initDataUnsafe.start_param (payload кнопки)
    if (platform === 'max' && webapp) {
        const startParam = webapp.initDataUnsafe?.start_param;
        if (startParam) return startParam;
    }

    return null;
}

export function expand() {
    try {
        if (webapp) webapp.expand();
    } catch (e) {
        console.warn('expand() not supported:', e);
    }
}

export function ready() {
    try {
        if (webapp) webapp.ready();
    } catch (e) {
        console.warn('ready() not supported:', e);
    }
}

export function enableClosingConfirmation() {
    try {
        if (webapp) webapp.enableClosingConfirmation();
    } catch (e) {
        console.warn('enableClosingConfirmation() not supported:', e);
    }
}

export function sendData(data) {
    try {
        if (platform === 'telegram' && webapp) {
            webapp.sendData(data);
        } else if (platform === 'max' && webapp) {
            // MAX Mini App не имеет sendData — отправляем через API
            // Для MAX заказ создаётся через бот, не через sendData
            console.log('MAX sendData (via API):', data);
            // TODO: отправить данные через fetch к MAX боту или Django API
        }
    } catch (e) {
        console.warn('sendData error:', e);
    }
}

export function close() {
    try {
        if (webapp) webapp.close();
    } catch (e) {
        console.warn('close() not supported:', e);
        window.close();
    }
}

export function getMainButton() {
    if (!webapp) return null;
    if (platform === 'telegram') return webapp.MainButton;
    // MAX не имеет MainButton — вернём null, UI покажет обычную HTML кнопку
    return null;
}

export function getLocationManager() {
    if (!webapp) return null;
    if (platform === 'telegram') return webapp.LocationManager;
    // MAX не имеет LocationManager
    return null;
}

export function sendHapticFeedback() {
    try {
        if (platform === 'telegram' && webapp) {
            webapp.HapticFeedback.impactOccurred("medium");
        } else if (platform === 'max' && webapp && webapp.HapticFeedback) {
            webapp.HapticFeedback.impactOccurred("medium");
        }
    } catch (e) {
        console.warn('HapticFeedback not supported:', e);
    }
}

export function onViewportChanged(callback) {
    try {
        if (platform === 'telegram' && webapp) {
            webapp.onEvent("viewportChanged", callback);
        }
        // MAX: нет аналога viewportChanged
    } catch (e) {
        console.warn('onViewportChanged not supported:', e);
    }
}

export default {
    platform,
    webapp,
    getPlatform,
    getAuthToken,
    expand,
    ready,
    enableClosingConfirmation,
    sendData,
    close,
    getMainButton,
    getLocationManager,
    sendHapticFeedback,
    onViewportChanged,
};
